import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Navbar from "./Navbar";
import "../../styles/pages.css";

export default function PageShell({ title, children }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems = [
    { label: `Signed in: ${user?.username || "Player"}`, onClick: () => navigate("/") },
    { label: "Play Game", onClick: () => navigate("/game") },
    { label: "My Profile", onClick: () => navigate("/profile") },
    { label: "Bet History", onClick: () => navigate("/my-bets") },
    { label: "Results", onClick: () => navigate("/results") },
    { label: "Deposit", onClick: () => navigate("/deposit") },
    { label: "Withdraw", onClick: () => navigate("/withdraw") },
    { label: "Logout", onClick: () => { logout(); navigate("/login", { replace: true }); } },
  ];

  return (
    <>
      <Navbar menuItems={menuItems} />
      <div className="pg">
        <div className="pg-title">
          <button className="pg-back" onClick={() => navigate("/game")}>Back to game</button>
          <h1>{title}</h1>
        </div>
        <main className="pg-body">{children}</main>
      </div>
    </>
  );
}
